$(document).on('turbolinks:load', function() {
  if ($('.lightbox a').length > 0) {
    var gallery = $('.lightbox a').simpleLightbox();

    $('.lightbox-button').click(function() {
      gallery.open();
    });
  };
});